import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Privacy Policy" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
                  </HeadingRow>
          <Text>
                 <p>Effective Date: March 1st, 2024</p>

            <p>
              Welcome to Red Falcon Games! Red falcon Company is committed to
              protecting your personal information and privacy. This Privacy
              Policy Agreement will explain how we collect, use, and protect the
              information you provide to us while using all Red Falcon games game.
              Please read this agreement carefully before using our services.
            </p>

            <p>
              We use Your Personal data to provide and improve the Service. By
              using the Service, You agree to the collection and use of
              information in accordance with this Privacy Policy.
            </p>

            <p>
                Thank you for playing our games! This Privacy Policy describes:
            </p>
            <ul>
              <li>
                <p>
                     The ways we collect personal data about you and why we do so
                </p>
              </li>
              <li>
                <p>
                                  How we use your personal data, and
                </p>
              </li>
              <li>
                              The choices you have about your personal data.
              </li>
            </ul>
                      <p>
                          This Privacy Policy applies to Red falcon's games, store, sites and related services, which we here collectively call the Service. We may periodically update this Privacy Policy by posting a new version on falcon-games.com. If we make any material changes, we will notify you as required under applicable law, including by posting a notice in the Service prior to the change becoming effective. Your continued use of the Service after the effective date will be subject to the new Privacy Policy.
                      </p>
                      
                      <h2>THE DATA WE COLLECT</h2>
                      <p>
                          The categories of personal data we collect depend on the Services you use, and the requirements of applicable law.
                      </p>
                      <p>
                          Data you provide us directly.
                      </p>
                          <p>
                              ▪Contact information (such as email address)
                          </p>
                      <p>
                          ▪ Player name or ID and password
                      </p>
                      <p>
                          ▪ Profile information (such as profile photo)
                      </p>
                      <p>
                          ▪ Your messages and other content you submit when you use the Service (such as chat logs and player support tickets)
                      </p>
                      <p>
                          ▪ Data you provide in connection with surveys, promotions, sweepstakes, competitions and other events
                      </p>
                      <p>
                          ▪ Our payment service providers will collect your payment details in connection with any purchases you make through the Red Falcon Store
                      </p>
                      <h2>
                          Data we collect automatically.
                      </h2>
                      <p>
                          ▪ Data about your account and game progress, including in most cases an automatically created internal account ID
                      </p>
                      <p>
                          ▪ Your IP address and mobile device identifiers (such as your device or advertising ID)
                      </p>
                      <p>
                          ▪ Data about your device, such as device name and operating system, browser type and language, internet service provider, and mobile carrier
                      </p>
                      <p>
                          ▪ Data we collect with cookies and similar technologies (see more below)
                      </p>
                      <p>
                          ▪ Approximate location data (as derived from IP address)
                      </p>
                      <p>
                          ▪ Data about your use of the Service, such as gameplay data, purchases made and your interactions with other players inside the Service
                      </p>
                      <p>
                          You also have the option to create a Red Falcon ID using your email address or other contact information.
                      </p>
                      <h2>
                          Data we collect from our partners.
                      </h2>
                      <p>
                          We also use third-party partners, such as social networking sites, data analytics providers and advertising networks to supplement information we have about you, such as:
                      </p>
                      <p>
                          ▪ Data we receive if you link a third-party tool with the Service (such as LINE, WeChat or Meta in some markets)
                      </p>
                      <p>
                          ▪ Demographic data (such as to determine the coarse location of your IP address)
                      </p>
                      <p>
                          ▪ Data to fight fraud (such as refund abuse in games or click fraud in advertising)
                      </p>
                      <p>
                          ▪ Data from platforms that the games run on or data from payment service providers (such as payment verification data)
                      </p>
                      <p>
                          ▪ Data for advertising and analytics purposes (such as surveys), so we can provide you a better Service
                      </p>
                      <p>
                          ▪ Data that you have made available to us from a third party service (such as LINE, WeChat or Meta in some markets) via your privacy settings
                      </p>
                      <h2>
                          WHY DO WE COLLECT YOUR DATA
                      </h2>
                      <p>
                          We use your data for a variety of business purposes, such as:
                      </p>
                      <p>
                          To make the Service work.
                      </p>
                      <p>
                          To perform the contract, we process data necessary to
                      </p>
                      <p>
                          ▪ Create accounts and allow you to play our games and use our Service
                      </p>
                      <p>
                          ▪ Operate the Service
                      </p>
                      <p>
                          ▪ Verify and confirm payments
                      </p>
                      <p>
                          ▪ Provide and deliver products and services you request
                      </p>
                      <p>
                          ▪ Send you Service-related communications
                      </p>
                      <h2>
                          To make the Service more suitable for our players.
                      </h2>
                      <p>
                          To provide a great Service to our players, we have a legitimate interest to collect and process necessary data to
                      </p>
                      <p>
                          ▪ Update and develop player profiles
                      </p>
                      <p>
                          ▪ Develop and improve the Service and player experience
                      </p>
                      <p>
                          ▪ Manage our relationship with you
                      </p>
                      <p>
                          ▪ Provide social features as part of the Service
                      </p>
                      <p>
                          ▪ Customize your Service experience
                      </p>
                      <p>
                          ▪ Respond to your comments and questions and provide player support
                      </p>
                      <p>
                          ▪ Provide you Red Falcon offers in the Service as well as in other websites and services (including by email)
                      </p>
                      <p>
                          ▪ Send you related information, such as updates, security alerts, and support messages
                      </p>
                      <p>
                          ▪ Enable you to communicate with other players
                      </p>
                      <h2>
                          To show personalized advertisements.
                      </h2>
                      <p>
                          To show you personalized advertisements in the Service and elsewhere (including email) we have a legitimate interest to process necessary data to
                      </p>
                      <p>
                          ▪ Track the content you access in connection with the Service and your online behavior
                      </p>
                      <p>
                          ▪ Deliver, target and improve our advertising and the Service
                      </p>
                      <h2>
                          To keep the Service safe and fair.
                      </h2>
                      <p>
                          Ensuring a level playing field in the Service is a top priority for us. For more information on our acceptable use policy; Red Falcon Terms of Service.
                      </p>
                      <p>
                          In order to keep the Service and its social features safe and fair, to fight fraud and ensure acceptable use otherwise, we have a legitimate interest to process necessary data to
                      </p>
                      <p>
                          ▪ Analyze and monitor use of the Service and its social features
                      </p>
                      <p>
                          ▪ Moderate chats either automatically or manually
                      </p>
                      <p>
                          ▪ Take action against fraudulent or misbehaving players
                      </p>
                      <h2>
                          To analyze, profile, and segment.
                      </h2>
                      <p>
                          In all of the above cases and purposes, we may analyze, profile and segment all collected data.
                      </p>
                      <h2>
                          With your consent.
                      </h2>
                      <p>
                          With your consent, we may process your data for additional purposes.
                      </p>
                      <p>
                          We may also collect and use your device identifiers to display and personalize in-game ads and serve behaviorally targeted advertising as explained below. Where applicable, we may collect your advertising identifier (IDFA, GAID), vendor identifier, IP address, device ID and other device identifiers (country, os version, device model, client version) for these purposes. Under applicable privacy laws, including the General Data Protection Regulation (GDPR), we are required to ask your consent to do so.
                      </p>
                      <p>
                          This data is shared with your consent so that our ad partners can deliver the right ad and optimize the ad content to make sure you don’t see the same ad multiple times. We share your device identifiers with selected partners for such ad delivery and personalization.
                      </p>
                      <p>
                          You can manage your consent in the game settings and limit ad tracking in your device settings. Please note that opt-outs are specific to each browser and device and it may take a little bit of time before your opt-out will take effect.
                      </p>
                      <p>
                          For mobile advertising in apps, you can reset your Advertising Identifier and depending on your device, select to opt out of interest-based ads (Android) or turn on the Limit Ad Tracking setting (iOS).
                      </p>
                      <p>
                          The partners operate the ad network and mediation platform, as well as facilitate and participate in ad inventory bidding. The partners may also use the device identifiers for fraud detection purposes based on their legitimate interest. For more information, please check the partners’ privacy policies.
                      </p>
                      <p>
                          ironSource Privacy Policy: <a href="https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/#step-1" target="_blank" rel="noopener noreferrer">https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/#step-1</a>
                      </p>
                      <p>
                          Vungle Privacy Policy: <a href="https://vungle.com/privacy/" target="_blank" rel="noopener noreferrer">https://vungle.com/privacy/</a>
                      </p>
                      <p>
                          Google Privacy Policy: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
                      </p>
                      <p>
                          Liftoff Privacy Policy: <a href="https://liftoff.io/privacy-policy/" target="_blank" rel="noopener noreferrer">https://liftoff.io/privacy-policy/</a>
                      </p>
                      <p>
                          Mintegral Privacy Policy: <a href="https://www.mintegral.com/en/privacy" target="_blank" rel="noopener noreferrer">https://www.mintegral.com/en/privacy</a>
                      </p>
                      <p>
                          Unity Ads Privacy Policy: <a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://unity.com/legal/privacy-policy</a>
                      </p>
                      <p>
                          Facebook Privacy Policy: <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer">https://www.facebook.com/privacy/policy/</a>
                      </p>
                      <p>
                          Apple Search Ads: <a href="https://searchads.apple.com/privacy" target="_blank" rel="noopener noreferrer">https://searchads.apple.com/privacy</a>
                      </p>
                      <p>
                          Applovin Privacy Policy: <a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer">https://www.applovin.com/privacy/</a>
                      </p>
                      <p>
                          inMobi Privacy Policy: <a href="https://advertising.inmobi.com/privacy-policy" target="_blank" rel="noopener noreferrer">https://advertising.inmobi.com/privacy-policy</a>
                      </p>
                      <p>
                          Pangle Privacy Policy: <a href="https://www.pangleglobal.com/zh/privacy" target="_blank" rel="noopener noreferrer">https://www.pangleglobal.com/zh/privacy</a>
                      </p>
                      <p>
                          DT Exchange Privacy Policy: <a href="https://www.digitalturbine.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://www.digitalturbine.com/legal/privacy-policy</a>
                      </p>
                      <p>
                          Chartboost Privacy Policy: <a href="https://docs.chartboost.com/en/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://docs.chartboost.com/en/legal/privacy-policy</a>
                      </p>
                      <p>
                          TapSDK Privacy Policy: <a href="https://www.tapdb.com/tapsdk-privacy.html" target="_blank" rel="noopener noreferrer">https://www.tapdb.com/tapsdk-privacy.html</a>
                      </p>
                      <p>
                          talkingdata Privacy Policy: <a href="https://www.talkingdata.com/privacy.jsp" target="_blank" rel="noopener noreferrer">https://www.talkingdata.com/privacy.jsp</a>
                      </p>

                      <h2>
                          WHO CAN SEE YOUR DATA
                      </h2>
                      <p>
                          Apart from Red Falcon, your data can be accessed by others in the following situations:
                      </p>
                      <p>
                          Other players and users.
                      </p>
                      <p>
                          Social features are a core component of our games. Other players and users may, for example, see your profile data, in-game activities and read the messages you have posted.
                      </p>
                      <p>
                          Our service providers.
                      </p>
                      <p>
                          Red Falcon has vendors who help us to provide the Service. These vendors process your data only at and according to Red Falcon's instructions to provide the Service, and perform tasks such as hosting, player support, advertising, analytics and fraud prevention.
                      </p>
                      <p>
                          Other companies and public authorities.
                      </p>
                      <p>
                          In order to verify payments (with payment providers such as Paypal) and combat fraud and illegal activity, we may process and disclose data with other companies and organizations and provide it to public authorities in response to lawful requests.
                      </p>
                      <p>
                          We may also disclose your data based on your consent, to comply with the law or to protect the rights, property or safety of us, our players or others.
                      </p>
                      <p>
                          Advertising and Social Media partners.
                      </p>
                      <p>
                          The Service includes features from our partners, such as social media interaction tools, functionalities through application programming interfaces (APIs) or software development kits (SDKs) and in-game advertising. A list of these partners is shown above in the “With your consent” section. These partners may access your data and operate under their own privacy policies. We encourage you to check their privacy policies to learn more about their data processing practices.
                      </p>
                      <p>
                          These partners may access data regarding your activities and your device (such as your IP address, mobile identifiers, page(s) visited, location, time of day). We may also combine and share data we have collected about you with third-party advertising partners. These advertising partners may use this data (and similar data collected from other services) for purposes of delivering targeted advertisements to you when you visit third-party services within their networks. These partners may operate under their own privacy policies. This practice is commonly referred to as “interest-based advertising” or “online behavioral advertising.”
                      </p>
                      <h2>
                          INTERNATIONAL DATA TRANSFERS
                      </h2>
                      <p>
                          Our Service is global by nature and your data can therefore be transferred to anywhere in the world. Because different countries may have different data protection laws than your own country, we take steps to ensure adequate safeguards are in place to protect your data as explained in this Privacy Policy. Adequate safeguards that we may use include standard contractual clauses approved by EU Commission and other lawful safeguards.
                      </p>
                      <h2>
                          YOUR RIGHTS AND OPTIONS
                      </h2>
                      <p>
                          Opt out of marketing emails and other direct marketing.
                      </p>
                      <p>
                          Where allowed under applicable laws, Red Falcon may send you marketing communications based on the existing customer relationship.
                      </p>
                      <p>
                          You may opt out of receiving promotional communications, such as marketing emails from us by following the instructions in such communications, or by changing your in-game settings. The updated settings may not be effective immediately. Note that you may still continue to receive non-promotional communications from us, such as communications regarding the Service or updates to our Red Falcon Terms of Service or this Privacy Policy or transactional information e.g. relating to your purchases on the Service.
                      </p>
                      <h2>
                          Push Notifications
                      </h2>
                      <p>
                          We may send you push notifications through our mobile applications. You may at any time opt-out from receiving these types of communications by changing the settings on your mobile device.
                      </p>
                      <h2>
                          Opt-out of targeted advertising.
                      </h2>
                      <p>
                          You can opt-out of interest-based advertising on mobile applications by checking the privacy settings of your Android or iOS device and turning off “Allow Apps to Request to Track” or selecting "Limit Ad Tracking" (Apple iOS) or "Opt-out of Interest Based Ads" (Android). You can also opt out from personalized in-game offers through the options provided in the game settings (where applicable).
                      </p>
                      <p>
                          Access the personal data we hold about you.
                      </p>
                      <p>
                          If you request, we will provide you a copy of your personal data in an electronic format.
                      </p>
                      <h2>
                          Your other rights.
                      </h2>
                      <p>
                          You also have the right to correct your data, have your data deleted, object how we use or share your data, and restrict how we use or share your data. You can always withdraw your consent.
                      </p>
                      <p>
                          We will respond to all requests within a reasonable timeframe. If you have an unresolved privacy or data use concern that we have not addressed satisfactorily, you may also contact your local data protection authority within the European Economic Area, Switzerland or UK for unresolved complaints.
                      </p>
                      <p>
                          If you wish to exercise any of your data subject rights described above, please use the support options described in “Contact Us” above. We will respond to all requests in accordance with applicable laws. To protect your privacy, we may also take additional steps to verify your identity before fulfilling your request, such as by requesting you provide us a purchase receipt or other account information, asking you to link your email address with your game account (for example through game ID), or asking you to answer questions regarding your activities on our Services. Once you have verified your identity, you may also designate an authorized agent to exercise your rights on your behalf by providing the agent’s contact information to our customer support staff, as required by applicable law.
                      </p>
                      <p>
                          You have the right not to receive discriminatory treatment as a result of your exercise of these rights.
                      </p>
                      <h1>
                          HOW DO WE PROTECT YOUR DATA
                      </h1>
                      <h2>
                          Security Safeguards.
                      </h2>
                      <p>
                          In order to help ensure a secure and safe player experience, we are continuously developing and implementing administrative, technical and physical security measures to protect your data from unauthorized access or against loss, misuse or alteration.
                      </p>
                      <h2>
                          Data retention.
                      </h2>
                      <p>
                          We retain your data for as long as your account is active or as needed to provide you the Service. We may for example periodically de-identify unused game accounts, and we may regularly review and de-identify unnecessary data.
                          Note that if you ask us to remove your personal data, we will retain your data as necessary for our legitimate business interests, such as to comply with our legal obligations, resolve disputes, and enforce our agreements.
                      </p>
                      <h1>
                          CHILDREN
                      </h1>
                      <p>
                          Protecting children’s privacy online is very important to us. Generally, our Services are not directed to children under 13 (or other age as required by local law), and the Services do not knowingly collect personal data from children, except as described in the following paragraph.
                      </p>
                      <p>
                          For games that are not directed at children but nonetheless may appeal to them, we take additional steps to limit access to these Services based on the player’s age. For these Services, when a player indicates they are under 13 (or the applicable age in their territory), we will limit their access to certain features, such as social media and chat features, as well as certain types of notification alerts. We also limit the processing of personal data to only what is necessary to support the internal operations of our Services.
                      </p>
                      <p>
                          Please note that for some of our Services we may use a higher age limit (such as 16) than described in the above two paragraphs. We do this to provide a safe game experience for our players and to protect Young Players.
                      </p>
                      <p>
                          If you are a parent or guardian and wish to review personal data collected from your child, or have that information modified or deleted, you may contact us as described above. If we become aware that a child has provided us with personal data contrary to the above, we will delete any personal data we have collected, unless we have a legal obligation to keep it, and terminate the child’s account and/or revert them to the underage experience, as applicable.
                      </p>
                      <h1>
                          FOR CALIFORNIA RESIDENTS
                      </h1>
                      <p>
                          The following section applies to only to residents of California.
                      </p>
                      <h2>
                          1) DATA COLLECTION
                      </h2>
                      <p>
                          The categories of personal data we have collected in the preceding 12 months, and the sources of said data, are described in the section “THE DATA WE COLLECT”.
                      </p>
                      <h2>
                          2) DATA USE
                      </h2>
                      <p>
                          The business or commercial purposes for collecting your personal data are described in the section “WHY DO WE COLLECT YOUR DATA”.
                      </p>
                      <h2>
                          3) DATA DISCLOSURE AND/OR SALE
                      </h2>
                      <p>
                          We do not “sell” your personal data with third parties as most people would understand that term. However, we may share your cookie information and advertising identifiers with our third-party advertising platforms to deliver interest-based advertisements, attribute installs and optimize campaign performance. To the extent that practice is considered a “sale” under the CCPA, you may opt out of said sharing by following the steps described in “Opt-out of targeted advertising” section.
                      </p>
                      <p>
                          We do not have actual knowledge of any sale of personal data of minors under 16 years of age, as the term “sale” is defined under the CCPA.
                      </p>
                      <p>
                          In the preceding 12 months, we have disclosed the following categories of personal data as part of our Services:
                      </p>
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead>
                              <tr>
                                  <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>Category of Personal Data Collected</th>
                                  <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>Examples of Data Collected by Red Falcon</th>
                                  <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>Categories Of Third Parties Who May Receive Personal Data For A Business Purpose</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Identifiers</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>A real name, alias, unique personal identifier, online identifier, Internet Protocol address, email address, account name, or other similar identifiers.</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Other Players (username and profile only), Service Providers, Business Partners, Advertising Networks (Advertising identifier and IP address only)</td>
                              </tr>
                              <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Personal data categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e))</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>A name or telephone number.</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Service Providers</td>
                              </tr>
                              <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Protected classification characteristics under California or federal law</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Age.</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Service Providers, Advertising Networks (for compliance purposes only)</td>
                              </tr>
                              <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Commercial information</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Records of products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies.</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Service Providers, Advertising Networks</td>
                              </tr>
                              <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Internet or other electronic network activity</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Browsing history, information on a consumer's interaction with an internet website, application, or advertisement.</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Service Providers, Advertising Networks</td>
                              </tr>
                              <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Inferences drawn from other personal data to create a profile about a consumer</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Profile reflecting a consumer's preferences, characteristics and behavior.</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Service Providers</td>
                              </tr>
                          </tbody>
                      </table>

                      <p>
                          In addition to the sharing described above, we may share any information we collect about you with our affiliates, to protect us or others, or in the event of a merger, sale, or other asset transfer. See the section “WHO CAN SEE YOUR DATA” for more information.
                      </p>
                      <h2>
                          4) YOUR RIGHTS
                      </h2>
                      <p>
                          Your rights under California law are described in the section “Your Rights and Options” section.
                      </p>
                      <h1>
                          FOR TURKISH RESIDENTS
                      </h1>
                      <p>
                          Effective Date: June 1st, 2022
                      </p>
                      <p>
                          The following section applies to you if you are a data subject located in the Republic of Turkey.
                      </p>
                      <h2>
                          1) Data Collection & Processing
                      </h2>
                      <p>
                          Your personal data will only be processed under the data protection legislation, in particular the Turkish Law on Personal Data Protection Law w. no 6698 (“DPL”).
                      </p>
                      <p>
                          The categories of personal data we have collected, and the sources of said data, are described in the section “THE DATA WE COLLECT” in the global privacy policy.
                      </p>
                      <p>
                          The purposes for collecting your personal data are described in the section “WHY DO WE COLLECT YOUR DATA”. In addition to the above, your personal data shall be collected automatically and processed based on the following legal justifications under the DPL:
                      </p>
                      <p>
                          ▪ Article 5/2 (f)
                      </p>
                      <p>
                          ▪ Article 5/2 (c)
                      </p>
                      <p>
                          ▪ Article 5/1
                      </p>
                      <h2>
                          2) Your Rights
                      </h2>
                      <p>
                          You have the following legal rights, which are specified in Article 11 of the DPL, in relation to the personal information data we hold about you. As a data subject accessing services from the Republic of Turkey, you may apply to the data controller and (and to the extent permitted under applicable laws and regulations):
                      </p>
                      <p>
                          1.to learn whether your personal data are processed,
                      </p>
                      <p>
                          2.to demand for information as to if your personal data have been processed,
                      </p>
                      <p>
                          3.to learn the purpose of the processing of your personal data and whether these personal data are used in compliance with the purpose,
                      </p>
                      <p>
                          4.to know the third parties to whom your personal data are transferred in the country or abroad,
                      </p>
                      <p>
                          5.to request the rectification of the incomplete or inaccurate data, if any,
                      </p>
                      <p>
                          6.to request the erasure or destruction of your personal data under the conditions referred to in Article 7 of the DPL,
                      </p>
                      <p>
                          7.to request reporting of the operations carried out under sub-paragraphs (e) and (f) to third parties to whom your personal data have been transferred,
                      </p>
                      <p>
                          8.to object to the occurrence of a result against the person yourself by analyzing the data processed solely through automated systems,
                      </p>
                      <p>
                          9.to claim compensation for the damage arising from the unlawful processing of your personal data.
                      </p>

                      <h2>CONTACT US</h2>
                      <p>
                          If you have questions about data protection, or if you have any requests for resolving issues with your personal data, we encourage you to primarily contact us through the support features within each Red falcon game, so we can reply to you more quickly. Alternatively, you may contact:
                      </p>

                      <p>
                          Name of the controller: Red Falcon Games Limited.
                      </p>
                      <p>
                          Address: Room 601-2, 6th Floor, Building 19, Huaxia Center, Cangqian Subdistrict, Yuhang District, Hangzhou, Zhejiang Province, China.
                      </p>
                      <p>
                          Attn: Privacy
                      </p>
                      <p>
                          email: support@falcon-games.com
                      </p>

                      <h1>
                          FOR SOUTH KOREAN RESIDENTS
                      </h1>
                      <p>
                          개인정보의 파기
                      </p>
                      <p>
                          당사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
                      </p>
                      <p>
                          정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 처리 목적이 제한되도록 해당 개인정보를 분리합니다.
                      </p>
                      <p>
                          법령에 의해 일정기간 보관되어야 하는 개인정보 및 해당 법령은 다음과 같습니다.
                      </p>
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead>
                              <tr>
                                  <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>관련 법령</th>
                                  <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>수집 정보</th>
                                  <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>보유기간</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }} rowSpan="2">통신비밀보호법</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>서비스 이용 관련 정보(웹사이트 방문기록)</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>3개월</td>
                              </tr>
                              <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>3년</td>
                              </tr>
                              <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }} rowSpan="2">전자상거래 등에서의 소비자 보호에 관한 법률</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>계약 또는 청약철회 등에 관한 기록</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>5년</td>
                              </tr>
                              <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>대금결제 및 재화 등의 공급에 관한 기록</td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>5년</td>
                              </tr>
                          </tbody>
                      </table>

                      <p>
                          개인정보 파기의 절차 및 방법은 다음과 같습니다.
                      </p>
                      <p>
                          ▪ 파기절차: 당사는 파기 사유가 발생한 개인정보를 선정하고, 당사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
                      </p>
                      <p>
                          ▪ 파기방법: 당사는 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 그 외 기록, 인쇄 자료, 서면, 또는 기록 장치의 경우 분쇄기로 분쇄하거나 소각하여 파기합니다.
                      </p>
                      <p>
                          개인정보의 국외 수집
                      </p>
                      <p>
                          당사는 귀하의 개인정보를 국외에서 수집하여 처리하고 있습니다.
                      </p>
                      <p>
                          ▪ 귀하의 개인정보는 EU/EEA 지역 및 미국 내에 물리적으로 저장됩니다.
                      </p>
                      <h2>
                          개인정보의 국외 이전
                      </h2>
                      <p>
                          다음과 같이 귀하의 개인정보가 국외에 이전됩니다.
                      </p>
                      <p>
                          ▪ 국외이전의 법적 근거 : 개인정보 보호법 제28조의8 제1항 제3호 가목(계약이행을 위한 국외 처리위탁・보관)
                      </p>
                      <p>
                          ▪ 개인정보를 이전받는 자 :
                          <a href="mailto:aws-korea-privacy@amazon.com">Amazon Web Services, Inc. (aws-korea-privacy@amazon.com)</a>,
                          <a href="mailto:googlekrsupport@google.com">Google Cloud Platform (googlekrsupport@google.com)</a>
                      </p>

                      <p>
                          ▪ 이전되는 개인정보 항목 : 본 방침에 기재된 수집항목 일체
                      </p>
                      <p>
                          ▪ 이전되는 국가 : 미국
                      </p>
                      <p>
                          ▪ 이전 일시/방법 : 네트워크를 통해 수시로
                      </p>
                      <p>
                          ▪ 이전받는 자의 개인정보 이용목적: 클라우드를 통한 고객정보 보관
                      </p>
                      <p>
                          ▪ 이전받는 자의 개인정보 보유ㆍ이용 기간 : 본 방침에 기재된 보유기간 범위 내에서 당사와의 계약 종료 시까지
                      </p>
                      <p>
                          귀하의 개인정보를 해외로 이전하는 것을 원하지 않는 경우, 법무 부서에 문의하십시오(개인 정보 보호 정책의 문의처 섹션 참조). 그러나 모든 개인정보가 그러하듯이 플레이어가 수집한 정보는 귀하가 개인 정보의 해외 전송을 거부하는 경우 Red Falcon Ltd 로 전송됩니다. 데이터가 있는 경우 당사는 귀하에게 서비스를 제공하지 못할 수도 있습니다.
                      </p>
                      <h2>
                          개인정보 처리방침의 변경
                      </h2>
                      <p>
                          이 개인정보 처리방침은 2024.03.01.부터 적용됩니다.
                      </p>
                     
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
